export const setNestedObjectValue = (object, keyPathArray, value) => {
    keyPathArray.reduce((acc, key, index, array) => {
        if (index + 1 < array.length) {
            acc[key] = acc[key] || {};
        } else {
            acc[key] = value;
        }
        return acc[key];
    }, object);
};
